import NavbarV2 from '../../components/navbarV2/NavbarV2';
import './IkeaOrdersV2.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/material';
import { FaCube } from 'react-icons/fa';
import PrintHero from '../../components/PrintHero/PrintHero';
import IkeaOrdersList from '../../components/IkeaOrdersList/IkeaOrdersList';
import ListEmptyStateV2, { ListPageLoadingV2 } from '../../components/listEmptyStateV2/ListEmptyStateV2';

const formatDate = (date) => date.toISOString().split('T')[0];

const IkeaOrdersV2 = () => {
    const [list, setList] = useState([]);
    const [fetchDone, setFetchDone] = useState(false);
    const [startDate, setStartDate] = useState(formatDate(new Date())); // Defaults to today
    const [endDate, setEndDate] = useState(formatDate(new Date())); // Defaults to today
    const [printing, setPrinting] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getList();
    }, []);

    const getList = () => {
        setFetchDone(false);
        setList([]);
    
        let url = `${process.env.REACT_APP_API}/api/getIkeaOrders`;
    
        const params = new URLSearchParams();
    
        params.append('startDate', startDate);
        params.append('endDate', endDate);
    
        url += `?${params.toString()}`;
    
        fetch(url)
          .then(async (response) => {
            if (response.status === 200) {
              if (localStorage.getItem('account') !== null) {
                const data = await response.json();
                setList(data);
              } else {
                navigate('/');
              }
            }
          })
          .catch((error) => {
            console.error('Error fetching the report:', error);
          })
          .finally(() => setFetchDone(true));
      };

    const handleStartDateChange = (event) => {
        setStartDate(event.target.value);
    };
    
      const handleEndDateChange = (event) => {
        setEndDate(event.target.value);
    };    

    const print = () => {
        setPrinting(true);
        setTimeout(() => {
            window.print();
          }, "1000");
    }

    window.onbeforeprint = (event) => {
        setPrinting(true);
    };
    
    window.onafterprint = (event) => {
        setPrinting(false);
    };

    return (
        <div className="ikeaorders mb-50">
            {printing ? <PrintHero /> : <NavbarV2 />}
            
            <h1 className="mt-50 mb-30 page-title">Ikea Orders</h1>
            {(localStorage.getItem('admin') == "true") && !printing && <Container maxWidth="lg" className="mt-20 orders-filters">
                <div style={{ display: 'flex' }}>
                    <div className="input-group">
                        <label>Start Date</label>
                        <input type="date" value={startDate} onChange={handleStartDateChange} />
                    </div>

                    <div className="input-group">
                        <label>End Date</label>
                        <input type="date" value={endDate} onChange={handleEndDateChange} />
                    </div>
                </div>
                <div className="search-button-wrapper">
                    <button onClick={() => getList()}>Search</button>
                    <button onClick={() => print()}>Print</button>
                </div>
            </Container>}

            {!fetchDone && <ListPageLoadingV2 />}
            {fetchDone && list.length === 0 && (
                <ListEmptyStateV2
                    icon={FaCube}
                    title="No IKEA orders in this range"
                    description="Try widening the date range or pick different start and end dates, then search again."
                />
            )}
            {list.length > 0 && <IkeaOrdersList data={list} />}
        </div>
    );
}

export default IkeaOrdersV2;